import {eventWorkspaceRoute} from "./eventWorkspaceRoutes";

export type LegacyWorkspaceSection =
    | "overview"
    | "settings"
    | "registration-fees"
    | "accommodation"
    | "activities"
    | "registration-form"
    | "participants"
    | "rooming"
    | "payments"
    | "notifications";

type ResolveLegacyAdminRouteOptions = {
    section?: LegacyWorkspaceSection;
    fallbackPath?: string;
};

const parsePositiveInt = (value: string | null) => {
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
};

export const resolveLegacyAdminRoute = (
    search: string,
    {fallbackPath, section = "overview"}: ResolveLegacyAdminRouteOptions = {}
) => {
    if (fallbackPath) {
        return fallbackPath;
    }

    const eventId = parsePositiveInt(new URLSearchParams(search).get("eventId"));

    if (eventId) {
        return eventWorkspaceRoute(eventId, section);
    }

    return "/Admin/Events";
};
